import { useEffect, useState } from "react";
import { Hero, FinalCta, Footer } from "@/components/teaser/Frame";
import { Glimpse, StoryCarousel, Tillys, Taste, Team } from "@/components/teaser/Sections";
import { Smoke } from "@/components/Smoke";
import { CookieBanner } from "@/components/CookieBanner";
import { useSiteConfig } from "@/lib/useSite";
import { getConsent, track } from "@/lib/track";
import { startLenis } from "@/lib/motion";
import { applySeo } from "@/lib/seo";

export default function Teaser() {
  const { config } = useSiteConfig();
  const [showCookies, setShowCookies] = useState(() => !getConsent());
  useEffect(() => startLenis(), []);
  useEffect(() => { track("board_view"); }, []);
  useEffect(() => { if (config?.seo) applySeo(config.seo); }, [config]);
  const p = config?.page || {};
  const links = config?.links || {};

  if (config === null) return <div className="min-h-screen bg-[#131413]" />;
  return (
    <div className="grain relative min-h-screen bg-[#131413] text-[#F2EBDD]" data-testid="teaser-page">
      <Smoke />
      <main>
        <Hero c={p.hero} config={config} />
        <Glimpse c={p.glimpse} />
        <StoryCarousel c={p.story} />
        <Tillys c={p.tillys} />
        <Taste c={p.taste} />
        <Team c={p.team} />
        <FinalCta c={p.final} config={config} />
      </main>
      <Footer links={links} credits={config?.footer_credits} logo={p.brand?.logo} privacyText={config?.privacy_text} termsText={config?.offer?.terms_text} onCookies={() => setShowCookies(true)} />
      {showCookies && <CookieBanner tracking={config?.tracking || {}} privacyHref={links.privacy_url || "/privacy"} onDone={() => setShowCookies(false)} />}
    </div>
  );
}
